import * as XLSX from 'xlsx';
import { useEffect, useState, useContext } from "react";
import $ from "jquery";
import {
    useNavigate
  } from "react-router-dom";
  import UserContext from "../../contexts/UserContext";
import {Button,Modal,Form}  from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import {BsTrash3} from 'react-icons/bs';

const Niyaaz = () => {

  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [niyaazData,setNiyaazData] = useState(null);
  const {user,setUser} = useContext(UserContext);
  const [message, setMessage] = useState('');
  const [variant,setVariant] = useState(null);

  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function getData(userId){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
        }else{
          setUser(null)
          navigate("/login",{state: { message: response.message }})
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }

  function sendFileData(niyaz){
    $.ajax({
        type:"POST",
        url:process.env.REACT_APP_API_URL+"/uploadNiyaaz",
        data:{niyaz},
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
        success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    navigate("/login");
                  }
                  if(response.message){
                      if(response.message.includes("success")){
                        setVariant("success")
                      }else{
                        setVariant("danger")
                      }
                      setMessage(response.message)
                  }  
                  getNiyaazData();
            
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setMessage("Something went wrong ! Please try again")
        }
    })
}

const newNiyaaz = (event) => {
    event.preventDefault();
    $.ajax({
        type:"POST",
        url:process.env.REACT_APP_API_URL+"/addNiyaaz",
        data:{date:event.target.date.value,name:event.target.name.value},
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
        crossDomain: true, 
        success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    navigate("/login");
                  }
                if(response.message){
                    if(response.message.includes("success")){
                        setVariant("success")
                      }else{
                        setVariant("danger")
                      }
                    setMessage(response.message)
                }  
                  getNiyaazData()
        //   return  setDataArr(response);
            
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setMessage("Something went wrong ! Please try again")
        }
    })
    handleClose();
}

const deleteNiyaaz = (data) => {
    $.ajax({
        type:"DELETE",
        url:process.env.REACT_APP_API_URL+"/deleteNiyaaz",
        data:{id:data._id},
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
        crossDomain: true, 
        success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    navigate("/login");
                  }
                if(response.message){
                    if(response.message.includes("success")){
                        setVariant("success")
                      }else{
                        setVariant("danger")
                      }
                    setMessage(response.message)
                }  
                  getNiyaazData()
            
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setMessage("Something went wrong ! Please try again")
        }
    })
}

function getNiyaazData(){
    $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getNiyaaz",
        dataType: 'json',
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
            success : function(response){
                if(response.message  && response.message.includes("Error in auth")){
                    navigate("/login");
                  }
                if(response.message){
                    setMessage(response.message)
                    if(response.message.includes("success")){
                        setVariant("success")
                      }else{
                        setVariant("danger")
                      }
                }  
                  setNiyaazData(response)
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setMessage("Something went wrong ! Please try again")
        }
    })
}

function UploadProcess() {
        //Reference the FileUpload element.
        var fileUpload = document.getElementById("fileUpload");
    
        //Validate whether File is valid Excel file.
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
    
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        GetTableFromExcel(e.target.result);
                    };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        GetTableFromExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Please upload a valid Excel file.");
        }
};    

function GetTableFromExcel(data) {
    //Read the Excel File data in binary
    var workbook = XLSX.read(data, {
        type: 'binary',
        cellDates: true
    });

    //get the name of First Sheet.
    var Sheet = workbook.SheetNames[0];

    //Read all rows from First Sheet into an JSON array.
    var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[Sheet]);

    var json_object = JSON.stringify(excelRows);

    var parsed = JSON.parse(json_object);

    var niyaaz =[];

    parsed.map((object)=>{
        if(object['Thaali (Y/N)'] === 'Y' && new Date(object['Eng. Date'])>new Date() &&  object['Niyaaz Karnar Name'] && object['Niyaaz Karnar Name'].length>0){
            niyaaz.push({
                date: new Date(new Date(object['Eng. Date']).setDate(new Date(object['Eng. Date']).getDate()+1)),
                name: object['Niyaaz Karnar Name']
            })
        }
    })
    sendFileData(niyaaz);
};

useEffect(()=>{
    try{
    if(!user && localStorage.getItem('userSession')){
      getData(JSON.parse(localStorage.getItem('userSession')))
    }else{
      if(!user){
        navigate("/login")
      }
    }
    getNiyaazData();
  }catch(e){
    if(!user){
      navigate("/login")
    }
  }
  },[])

const NiyaazCard = ({data}) => {
    const design = (
        <>
        <div className="minimal-payment-card">
            <div className="payment-details">
                <div className="info-item">
                <span className="info-label">Date:</span>
                <span className="info-value">{new Date(data.date).toDateString()}</span>
                </div>
                <div className="info-item">
                <span className="info-label">Niyaaz Karnar Name:</span>
                <span className="info-value">{data.name}</span>
                </div>
            </div>
                <div className="deleteIcon" onClick={()=>deleteNiyaaz(data)}>
                    <BsTrash3 />
                </div>
        </div>
        </>
    )
    return design;
}


    const design = (<>
    <Form.Group controlId="formFile" className="m-3 mb-2">
        <Form.Label>Upload File for Niyaaz Info</Form.Label>
        <Form.Control id="fileUpload" type="file" />
        <div className='d-flex mt-3 justify-content-end'>
            <Button className='w-100' style={{backgroundColor:'#884A39',borderColor:'#884A39'}} onClick={()=>{UploadProcess()}}> Upload File </Button>
        </div>
    </Form.Group> 
    <h6 style={{textAlign:'center'}}>(OR)</h6>
    <div className='d-flex mx-3 mt-2 justify-content-end'>
            <Button className='w-100' style={{backgroundColor:'#884A39',borderColor:'#884A39'}} onClick={handleShow}>Add New Niyaaz</Button>
    </div>
    {message && message.length>0?<Alert key='danger' variant={variant}>{message} !</Alert>:null}

    {
        niyaazData && niyaazData.length>0 ?
        niyaazData.sort(function(a, b) {
            return new Date(a.date) - new Date(b.date);
        }).map((data) =>{
            return <NiyaazCard data= {data}/>
        })
        :
        null
    }

    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Niyaaz</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={newNiyaaz}>
            <Form.Group className="mb-3" controlId="date">
                <Form.Label>Date : </Form.Label>
                <Form.Control type="date" name='date' placeholder="Select date" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="name">
                <Form.Label>Niyaaz Karnar Name : </Form.Label>
                <Form.Control type="text" name='name' placeholder="Enter Name" />
            </Form.Group>
            <Form.Group>
            <Button variant="primary" type="submit">
              Submit
            </Button>
            </Form.Group>
          </Form>
          </Modal.Body>
    </Modal>
    </>)
    return design;
}

export default Niyaaz;